import { defineStore } from "pinia";
import { ref } from 'vue';

export const useLoadingOverlay = defineStore("loadingOverlay", () => {
  /** State **/
  const is_visible = ref<boolean>(false);

  /** Actions **/
  function show(): void {
    console.log("[loading-overlay.show]: showing loading overlay");
    is_visible.value = true;
  }
  function hide(): void {
    console.log("[loading-overlay.hide]: hiding loading overlay");
    is_visible.value = false;
  }

  return { is_visible, show, hide }
});

// vim: softtabstop=2:shiftwidth=2
